
import React from 'react';
import PageLayout from '@/components/layout/PageLayout';
import SEOHead from '@/components/SEOHead';
import { TermsContent } from '@/components/legal/shared/TermsContent';

const TermsOfService: React.FC = () => {
  const jsonLd = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    "name": "Terms of Service - forkast",
    "description": "Terms of service and user agreement for forkast, the AI-powered family meal planning application.",
    "url": "https://forkast.in/terms",
    "isPartOf": {
      "@type": "WebSite",
      "name": "forkast",
      "url": "https://forkast.in"
    }
  };

  return (
    <>
      <SEOHead 
        title="Terms of Service - Legal Terms for forkast Users"
        description="Read our terms of service to understand how to use forkast responsibly. Legal information for AI-powered family meal planning service."
        jsonLd={jsonLd}
      />
      <PageLayout 
        title="Terms of Service"
        description="Effective Date: September 4, 2025 • Operated by Sébastien (EU) • Contact: forkast.in.app@gmail.com"
      >
        <div className="max-w-4xl mx-auto prose prose-gray mt-6">
          <TermsContent variant="web" />
        </div>
      </PageLayout>
    </>
  );
};

export default TermsOfService;
